import { Card, CardContent, CardHeader, Stack } from "@mui/material";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialTypography from "../../../components/MaterialTypography";
import { useLocation, useNavigate } from "react-router-dom";
import MaterialBox from "../../../components/MaterialBox";
import { useEffect, useReducer, useState } from "react";
import {
  createCustomerMaster,
  customerDataManage,
  customerMasterData,
  getCustomermasterById,
  updateCustomerMaster,
} from "./customerData";
import MaterialInput from "../../../components/MaterialInput";
import MaterialSelect from "../../../components/MasterSelect";
import Grid from "@mui/material/Grid2";
import MaterialButton from "../../../components/MaterialButton";
import { useLoading } from "../../../context/LodingContext";
import { useMutation } from "@apollo/client";
import Swal from "sweetalert2";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import PlaceIcon from "@mui/icons-material/Place";
import Location from "./Location";
import request from "graphql-request";
import BASEURL from "../../../pages/Utils/Baseurl";

const CustomerMasterForm = () => {
  const [customerData, dispatch] = useReducer(
    customerDataManage,
    customerMasterData
  );

  const statusOptions = [
    { value: "Active", label: "Active" },
    { value: "Blocked", label: "Blocked" },
  ];

  const [createCustomer] = useMutation(createCustomerMaster);
  const [updateCustomer] = useMutation(updateCustomerMaster);
  const { setCirleLoading } = useLoading();
  const [mapOpen, setMapOpen] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedLatLng, setSelectedLatLng] = useState(null);
  const [inputDisble, setInputDisble] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { userId } = useAuthData();

  const formType = location?.state?.type || "add";
  const formValue = location?.state?.customerId;

  useEffect(() => {
    if (formValue) fetchCustomerDatabyId(formValue);
  }, [formValue]);

  useEffect(() => {
    if (formType == "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [formType]);

  const fetchCustomerDatabyId = async (id) => {
    try {
      const res = await request(BASEURL, getCustomermasterById, { id });
      const success = res?.getCustomermasterById?.success;
      const data = res?.getCustomermasterById?.data;
      if (success && data) {
        dispatch({ name: "customerCode", value: data?.customerCode });
        dispatch({ name: "customerName", value: data?.customerName });
        dispatch({ name: "customerCategory", value: data?.customerCategory });
        dispatch({
          name: "status",
          value: { value: data?.status, label: data?.status },
        });
        dispatch({ name: "creditLimit", value: data?.creditLimit });
        dispatch({ name: "creditPeriod", value: data?.creditPeriod });

        const addrArray = Array.from({ length: 4 }, (_, i) => {
          const val = data?.addresses?.[i];
          return {
            id: val?.id || "",
            name: val?.address || "",
            lat: val?.latitude || "",
            lng: val?.longitude || "",
            status: !!val?.address,
          };
        });

        dispatch({ name: "addresses", value: addrArray });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleLocationSelect = (data) => {
    const { lat, lng, address } = data;
    if (selectedIndex !== null) {
      dispatch({
        name: "updateAddress",
        value: { index: selectedIndex, lat, lng, name: address },
      });
    }
  };

  const openMap = (index) => {
    setSelectedIndex(index);
    const current = customerData.addresses[index];
    setSelectedLatLng({
      lat: current.lat ? Number(current.lat) : null,
      lng: current.lng ? Number(current.lng) : null,
      address: current.name || "",
    });
    setMapOpen(true);
  };

  const checkAllFields = () => {
    return (
      customerData.customerCodeStatus === "success" &&
      customerData.customerNameStatus === "success" &&
      customerData.customerCategoryStatus === "success" &&
      customerData.statusStatus === "success" &&
      customerData.creditLimitStatus === "success" &&
      customerData.creditPeriodStatus === "success"
    );
  };

  const handleSubmit = async () => {
    setCirleLoading(true);

    try {
      const addressData = customerData.addresses?.map((val) => ({
        address: val.name,
        locationLat: Number(val.lat),
        locationLng: Number(val.lng),
      }));

      const updateAddressData = customerData.addresses?.map((val) => ({
        id: val.id,
        address: val.name,
        locationLat: Number(val.lat),
        locationLng: Number(val.lng),
      }));
      const inputData = {
        userId: userId,
        customerCode: customerData.customerCode,
        customerName: customerData.customerName,
        customerCategory: customerData.customerCategory,
        status: customerData.status.value,
        creditLimit: customerData.creditLimit,
        creditPeriod: customerData.creditPeriod,
        address: formType === "add" ? addressData : updateAddressData,
      };

      const response =
        formType === "add"
          ? await createCustomer({ variables: { input: inputData } })
          : await updateCustomer({
              variables: { input: { id: formValue, ...inputData } },
            });

      const res =
        formType === "add"
          ? response?.data?.createCustomerMaster
          : response?.data?.updateCustomerMaster;

      Swal.fire({
        position: "top",
        icon: res?.success ? "success" : "error",
        title: res?.message,
        showConfirmButton: true,
      }).then(() => res?.success && navigate("/customer-master"));
    } catch (err) {
      console.error(err);
    } finally {
      setCirleLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack direction="row" justifyContent="space-between">
              <MaterialTypography variant="h5" fontWeight="medium">
                {formType === "add"
                  ? "Add Customer Master Details"
                  : formType === "edit"
                  ? "Edit Customer Master Details"
                  : "View Customer Master Details"}
              </MaterialTypography>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={3}>
              {/* BASIC FIELDS */}
              <Grid size={{ lg: 3 }}>
                <MaterialTypography variant="caption" fontWeight="bold">
                  Customer Code <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialInput
                  name="customerCode"
                  value={customerData.customerCode}
                  placeholder="Enter Customer Code"
                  onChange={(e) =>
                    dispatch({ name: "customerCode", value: e.target.value.toUpperCase() })
                  }
                  error={customerData.customerCodeStatus === "error"}
                  success={customerData.customerCodeStatus === "success"}
                  disabled={inputDisble}
                />
              </Grid>

              <Grid size={{ lg: 3 }}>
                <MaterialTypography variant="caption" fontWeight="bold">
                  Customer Name <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialInput
                  name="customerName"
                  value={customerData.customerName}
                  placeholder="Enter Customer Name"
                  onChange={(e) =>
                    dispatch({ name: "customerName", value: e.target.value })
                  }
                  error={customerData.customerNameStatus === "error"}
                  success={customerData.customerNameStatus === "success"}
                  disabled={inputDisble}
                />
                {customerData.customerNameStatus === "error" && (
                  <p
                    style={{
                      fontWeight: "600",
                      fontSize: "12px",
                      color: "red",
                    }}
                  >
                    Please enter letters only.
                  </p>
                )}
              </Grid>

              <Grid size={{ lg: 3 }}>
                <MaterialTypography variant="caption" fontWeight="bold">
                  Customer Category <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialInput
                  name="customerCategory"
                  value={customerData.customerCategory}
                  placeholder="Enter Customer Category"
                  onChange={(e) =>
                    dispatch({
                      name: "customerCategory",
                      value: e.target.value,
                    })
                  }
                  error={customerData.customerCategoryStatus === "error"}
                  success={customerData.customerCategoryStatus === "success"}
                  disabled={inputDisble}
                />
              </Grid>

              <Grid size={{ lg: 3 }}>
                <MaterialTypography variant="caption" fontWeight="bold">
                  Status <span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialSelect
                  name="status"
                  value={customerData.status}
                  options={statusOptions}
                  onChange={(e, s) => dispatch({ name: s.name, value: e })}
                  isClearable
                  isDisabled={inputDisble}
                  error={customerData.statusStatus === "error"}
                  success={customerData.statusStatus === "success"}
                />
              </Grid>

              {/* ADDRESS FIELDS */}
              {customerData.addresses.map((addr, index) => (
                <Grid key={index} size={{ lg: 3 }}>
                  <MaterialTypography variant="caption" fontWeight="bold">
                    Address {index + 1}{" "}
                    {index === 0 && <span style={{ color: "red" }}>*</span>}
                    <PlaceIcon
                      sx={{ ml: 1, cursor: "pointer", color: "blue" }}
                      onClick={() => openMap(index)}
                    />
                  </MaterialTypography>
                  <MaterialInput
                    multiline
                    rows={3}
                    value={addr.name}
                    onChange={(e) =>
                      dispatch({
                        name: "updateAddressName",
                        value: { index, name: e.target.value },
                      })
                    }
                    disabled={inputDisble}
                  />
                  {addr.lat && (
                    <MaterialTypography
                      variant="caption"
                      display="block"
                      mt={1}
                    >
                      <b>Lat:</b> {addr.lat} | <b>Lng:</b> {addr.lng}
                    </MaterialTypography>
                  )}
                </Grid>
              ))}

              {/* CREDIT DETAILS */}
              <Grid size={{ lg: 3 }}>
                <MaterialTypography variant="caption" fontWeight="bold">
                  Credit Limit<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialInput
                  name="creditLimit"
                  type="number"
                  value={customerData.creditLimit}
                  onChange={(e) =>
                    dispatch({ name: "creditLimit", value: e.target.value })
                  }
                  error={customerData.creditLimitStatus === "error"}
                  success={customerData.creditLimitStatus === "success"}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                  disabled={inputDisble}
                />
              </Grid>

              <Grid size={{ lg: 3 }}>
                <MaterialTypography variant="caption" fontWeight="bold">
                  Credit Period<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
                <MaterialInput
                  name="creditPeriod"
                  type="number"
                  value={customerData.creditPeriod}
                  onChange={(e) =>
                    dispatch({ name: "creditPeriod", value: e.target.value })
                  }
                  error={customerData.creditPeriodStatus === "error"}
                  success={customerData.creditPeriodStatus === "success"}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-"].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
                    "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    "& input": {
                      MozAppearance: "textfield",
                    },
                  }}
                  disabled={inputDisble}
                />
              </Grid>
            </Grid>
          </MaterialBox>

          {/* ACTION BUTTONS */}
          <MaterialBox display="flex" justifyContent="flex-end" mt={3}>
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate("/customer-master")}
            >
              Cancel
            </MaterialButton>
            {formType !== "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleSubmit}
              >
                {formType === "add" ? "Submit" : "Update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>

      {/* LOCATION PICKER DIALOG */}
      <Location
        open={mapOpen}
        onClose={() => setMapOpen(false)}
        onSelectLocation={handleLocationSelect}
        selectedLatLng={selectedLatLng}
      />
    </DashboardLayout>
  );
};

export default CustomerMasterForm;
